<div
    [formGroup]="layoutStyleFormGroup"
    class="agpr-layoutStyleField"
>
    <div class="agpr-layoutStyleField-header">
        <label class="agpr-layoutStyleField-header-label">{{ ('PageBuilder.formField.layout.header.' + field.columnNumber + 'ColumnLayout' ) | localize }}</label>
        <div class="agpr-formField-headingButtons agpr-layoutStyleField-header-button">
            @if(field.allowExpertMode) {
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-code"
                    tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                    tooltipPosition="top"
                    (click)="saveExpertTemplate()"
                ></agpr-button>
            }
            <agpr-button
                class="agpr-formField-headingButton"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-floppy-disk"
                tooltip="PageBuilder.formField.tooltip.saveStyle"
                tooltipPosition="top"
                (click)="saveStyle()"
            ></agpr-button>
        </div>
    </div>

    <div class="agpr-layoutStyleField-settings">
        <div class="agpr-inputGroupRow agpr-layoutStyleField-styleState">
            <div class="agpr-inputGroupRow-dropdown agpr-layoutStyleField-styleState-dropdown">
                <agpr-dropdown-field
                    formControlName="styleState"
                    [id]="'layoutStyleField_styleStateDropdown'"
                    [field]="styleStateField"
                    [labelClass]="field.columnNumber === 1 ? 'agpr-dropdown-label--semibold' : ''"
                ></agpr-dropdown-field>
            </div>
            <div class="agpr-inputGroupRow-buttons agpr-layoutStyleField-styleState-button">
                <agpr-button
                    [id]="'layoutStyleField_styleStateButton'"
                    [style]="buttonTypes.block"
                    icon="fa-regular fa-duotone fa-gear"
                    tooltip="PageBuilder.formField.tooltip.manageStyles"
                    tooltipPosition="top"
                    (click)="manageStylesButtonClicked()"
                ></agpr-button>
            </div>
        </div>

        <div formGroupName="styles">
            @if (columnNumber > 1) {
                <label class="agpr-layoutStyleField-label" [class.agpr-layoutStyleField-label--textPrimary]="textPrimaryLabel">{{ 'PageBuilder.formField.layout.display.label' | localize }}</label>

                <agpr-dropdown
                    formControlName="displayRatio"
                    class="agpr-layoutStyleField-displayRatio"
                    optionStyleClass="agpr-layoutStyleField-displayRatio-option"
                    [id]="'layoutStyleField_displayRatio'"
                    [bindToValue]="true"
                    [options]="displayRatioDropdownOptions"
                    [itemTemplate]="itemTemplate"
                    ariaLabel="PageBuilder.formField.layout.displayRatio"
                ></agpr-dropdown>

                <ng-template #itemTemplate let-option let-selected="selected">
                    @if (option) {
                        <span [ngClass]="{ 'agpr-layoutStyleField-displayRatio-itemLabel--selected': selected }">{{ ('PageBuilder.formField.layout.displayRatio.' + option.value) | localize }}</span>
                        <div class="agpr-layoutStyleField-displayRatio-itemIcon">
                            @for (ratio of displayRatioEnumToArrayMap.get(option.value); let idx = $index; track idx) {
                                <div
                                    class="agpr-layoutStyleField-displayRatio-itemIcon-rectangle"
                                    [style.flex]="ratio"
                                ></div>
                            }
                        </div>
                    }
                </ng-template>
            }

            <div class="agpr-layoutStyleField-row agpr-layoutStyleField-flex">
                <div class="agpr-layoutStyleField-colorPicker">
                    <agpr-color-picker-field
                        formControlName="backgroundColor"
                        class="agpr-layoutStyleField-backgroundColor"
                        [id]="'layoutStyleField_backgroundColor'"
                        [field]="colorPickerField"
                    ></agpr-color-picker-field>
                </div>

                @if (columnNumber > 1) {
                    <div
                        formGroupName="verticalAlignment"
                        class="agpr-layoutStyleField-flex"
                    >
                        <agpr-radio
                            formControlName="top"
                            class="agpr-layoutStyleField-verticalAlignment-button"
                            [id]="'layoutVerticalAlignment_top'"
                            name="layout-vertical-alignment"
                            [value]="verticalAlignments.TOP"
                            [style]="radioTypes.button"
                            icon="fa-regular fa-duotone fa-objects-align-top"
                            iconTooltip="PageBuilder.formField.tooltip.alignTop"
                            hiddenLabel="PageBuilder.formField.tooltip.alignBlocksTop"
                        ></agpr-radio>
                        <agpr-radio
                            formControlName="middle"
                            class="agpr-layoutStyleField-verticalAlignment-button"
                            [id]="'layoutVerticalAlignment_middle'"
                            name="layout-vertical-alignment"
                            [value]="verticalAlignments.MIDDLE"
                            [style]="radioTypes.button"
                            icon="fa-regular fa-duotone fa-objects-align-center-vertical"
                            iconTooltip="PageBuilder.formField.tooltip.alignMiddle"
                            hiddenLabel="PageBuilder.formField.tooltip.alignBlocksMiddle"
                        ></agpr-radio>
                        <agpr-radio
                            formControlName="bottom"
                            class="agpr-layoutStyleField-verticalAlignment-button"
                            [id]="'layoutVerticalAlignment_bottom'"
                            name="layout-vertical-alignment"
                            [value]="verticalAlignments.BOTTOM"
                            [style]="radioTypes.button"
                            icon="fa-regular fa-duotone fa-objects-align-bottom"
                            iconTooltip="PageBuilder.formField.tooltip.alignBottom"
                            hiddenLabel="PageBuilder.formField.tooltip.alignBlocksBottom"
                        ></agpr-radio>
                    </div>
                }
            </div>

            @if (showCornerRadius) {
                <agpr-corner-radius
                    class="agpr-layoutStyleField-cornerRadius"
                    [id]="id + '_corner_radius'"
                    formControlName="cornerRadius"
                    [showInfoTooltip]="true"
                ></agpr-corner-radius>
            }

            <agpr-block-padding
                formControlName="padding"
                [id]="'layoutStyleField_blockPadding'"
            ></agpr-block-padding>

            @if (columnNumber > 1) {
                <div class="agpr-layoutStyleField-columnSpacing">
                    <agpr-number-input
                        formControlName="columnSpacing"
                        [id]="'layoutStyleField_columnSpacing'"
                        label="PageBuilder.formField.layout.columnSpacing.label"
                        unit="px"
                        [integerOnly]="true"
                        [min]="0"
                        [max]="200"
                    ></agpr-number-input>
                </div>
            }
        </div>
    </div>
</div>
